import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Briefcase, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import { formatDate } from "../lib/constants";

const OPEN_FOR_LABEL = {
  todos: "Cooperados e não cooperados",
  cooperados: "Apenas cooperados",
  publico: "Aberta ao público",
};

export default function VagasList() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/jobs").then((r) => setJobs(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="vagas-page" className="py-20">
      <div className="container-page">
        <div className="eyebrow mb-3">Trabalhe conosco</div>
        <h1 className="font-display text-5xl md:text-6xl text-forest-900 leading-[1.05] max-w-3xl">
          Oportunidades na <span className="italic text-copaiba-700">COOMFLONA</span>.
        </h1>
        <p className="text-forest-900/75 mt-5 max-w-2xl leading-relaxed">
          Quando temos vagas abertas, publicamos aqui. As oportunidades são para cooperados e também para a comunidade
          da Flona do Tapajós em geral.
        </p>

        {loading ? (
          <p className="mt-16 text-forest-900/60">Carregando vagas...</p>
        ) : jobs.length === 0 ? (
          <div className="mt-16 bg-cream-200 border border-cream-400 p-12 text-center">
            <Briefcase className="w-10 h-10 text-forest-700 mx-auto mb-4" />
            <h2 className="font-display text-2xl text-forest-900">Nenhuma vaga disponível no momento</h2>
            <p className="text-forest-900/75 max-w-xl mx-auto mt-3">
              No momento não temos processos seletivos abertos. Volte em breve — sempre lançamos novas oportunidades
              para cooperados e não cooperados da Flona do Tapajós. Para receber avisos, siga a cooperativa no
              Instagram <a href="https://instagram.com/coomflona.oficial" target="_blank" rel="noreferrer" className="underline text-forest-700 hover:text-copaiba-700">@coomflona.oficial</a>.
            </p>
          </div>
        ) : (
          <div className="mt-14 space-y-4">
            {jobs.map((j) => (
              <Link
                to={`/vagas/${j.id}`}
                key={j.id}
                data-testid={`job-card-${j.id}`}
                className="group block bg-white border border-cream-400 p-6 md:p-8 hover:bg-cream-200 transition-colors duration-300"
              >
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                  <div className="flex-1">
                    <div className="eyebrow mb-2">{OPEN_FOR_LABEL[j.open_for] || j.open_for}</div>
                    <h2 className="font-display text-2xl md:text-3xl text-forest-900 group-hover:text-copaiba-700 transition-colors leading-tight">
                      {j.title}
                    </h2>
                    <div className="flex flex-wrap gap-x-5 gap-y-2 mt-3 text-sm text-forest-900/70">
                      {j.community && (
                        <span className="inline-flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {j.community}</span>
                      )}
                      {j.contract_type && (
                        <span className="inline-flex items-center gap-1.5"><Briefcase className="w-3.5 h-3.5" /> {j.contract_type}</span>
                      )}
                      <span className="inline-flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" /> Publicada em {formatDate(j.created_at)}</span>
                    </div>
                    <p className="text-forest-900/75 mt-4 line-clamp-2 leading-relaxed">{j.description}</p>
                  </div>
                  <div className="shrink-0 self-start">
                    <span className="btn-primary !py-2.5 !px-5">
                      Ver vaga <ArrowUpRight className="w-4 h-4" />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
